import React from 'react';
import PropTypes from 'prop-types';
import SearchOption from './SearchOption';
import ShowAll from './ShowAll';
import { getSearchResultPhotoUrl } from "../../../utils/images";

// This function is necessary because we need a stateful component (in order to load the vibrant color)
// and the semantic-ui-react Search component requires a function as renderer.
const ResultRenderer = ({title, description, image, type}) => {

  if ( type === "showAll" ) return <ShowAll />;

  return <SearchOption title={title} description={description} imageURL={getSearchResultPhotoUrl(image, type)} />;
};

ResultRenderer.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string
};

export default ResultRenderer;
